import { Form,Button, Col, Row } from "react-bootstrap";

export default function TablePackageVolumePremium({ 
    simulate, 
    setSimulate,
    packagePeriod, 
    handleSetSimulatePremiums, 
    calculatePrice, 
    mode, 
    calculatedPrices}){

        const addRow = () => {
            const currentIds = simulate.arr_volume.map(row => row.id); 
            const newId = Math.max(0, ...currentIds) + 1; 
        
            const newRow = {
                package_master_id: simulate?.id ?? 0,
                id: newId, 
                seq: newId,
                volume: 0,
                active: true,
            };
        
            setSimulate({
                ...simulate,
                arr_volume: [...(simulate.arr_volume || []), newRow],
            });
        };

        const handleDeleteRow = (id) => {
            const arrVolume = simulate.arr_volume;
            let arrId = arrVolume.findIndex(x => x.id == id)
            if(arrId > -1)
                arrVolume.splice(arrId,1)
            setSimulate({ ...simulate, arr_volume: arrVolume });
        };

        const handleSetSimulateVolumes = async (event) => {
            const { name, value, checked, type } = event.target;
            const [me_name, id] = name.split('|');
            const volumes = simulate?.arr_volume ?? [];
            
            let volume = volumes.find(x => x.id === parseInt(id));
            
            if (volume) {
                volume[me_name] = type === 'checkbox' ? checked : parseFloat(value);
            } else {
                volume = {
                    package_master_id: simulate?.id ?? 0,
                    id: parseInt(id),
                    seq: parseInt(id),
                    volume: 0,
                    total: 0,
                    active: true,
                };
                volume[me_name] = type === 'checkbox' ? checked : parseFloat(value);
                volumes.push(volume);
            }
            
            setSimulate({ ...simulate, arr_volume: [...volumes] });
        };

        return(
            <>
                <Row className='mb-5'>
                    <Col className="me-3">
                        
                            {
                                simulate.package_type === 'addon-user' &&
                                <>
                                    <div>
                                    <Form.Label className='label-title'>ปริมาณผู้ใช้งาน</Form.Label>
                                    </div>
                                    <div>
                                        
                                        <Button 
                                            variant="outline-secondary" 
                                            type="button" 
                                            className=''
                                            disabled={mode === 'view'}
                                            onClick={event => addRow ()}
                                        >
                                            เพิ่มปริมาณผู้ใช้งาน
                                            <i className="fa-solid fa-plus ms-2"></i>
                                        </Button>
                                    </div>
                                </>
                            }
                            {
                                simulate.package_type === 'addon-storage' &&
                                <>
                                    <div>
                                        <Form.Label className='label-title'>ปริมาณการจัดเก็บข้อมูล</Form.Label>
                                    </div>
                                    <div>
                                        <Button 
                                            variant="outline-secondary" 
                                            type="button" 
                                            className=''
                                            disabled={mode === 'view'}
                                            onClick={event => addRow ()}
                                        >
                                            เพิ่มปริมาณการจัดเก็บข้อมูล
                                            <i className="fa-solid fa-plus ms-2"></i>
                                        </Button>
                                    </div>
                                </>
                                
                            }
                       
                            <table cellPadding={4} className="table table-none">
                                <thead>
                                    <tr>
                                        <th className="text-center">#</th>
                                        <th >ลำดับ</th>
                                        {
                                            simulate.package_type === 'addon-user' &&
                                            <th>ปริมาณผู้ใช้</th>
                                        }
                                        {
                                            simulate.package_type === 'addon-storage' &&
                                            <th>ปริมาณการจัดเก็บข้อมูล</th>
                                        }
                                        <th className="text-center">ใช้งาน</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {simulate.arr_volume?.map((row, index) => (
                                        <tr key={row.id}>
                                            <td className="text-center">
                                                <Button
                                                    variant="danger"
                                                    type="button"
                                                    style={{
                                                        color: "red",
                                                        padding: "8px",
                                                        background: "none",
                                                        border: "none",
                                                    }}
                                                    disabled={mode === "view"}
                                                    onClick={() => handleDeleteRow(row.id)}
                                                    //onClick={() => handleDeleteRow(index +1)}
                                                >
                                                   <i class="fa-solid fa-x"></i>
                                                </Button>
                                            </td>
                                            <td>{index + 1}</td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    name={`volume|${row.id}`}
                                                    plaintext={mode === "view"}
                                                    readOnly={mode === "view"}
                                                    className="w-100"
                                                    value={row.volume}
                                                    onChange={event => handleSetSimulateVolumes(event)}
                                                    placeholder={"ปริมาณ"}
                                                    required
                                                    step="any"
                                                />
                                            </td>
                                            <td className="text-center">
                                                <Form.Switch
                                                    name={`active|${row.id}`}
                                                    className="ms-0"
                                                    disabled={mode === "view"}
                                                    checked={row.active}
                                                    onChange={event => handleSetSimulateVolumes(event)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                    </Col>
                </Row>
                <Row className='mb-5'>
                    <Col className="me-3">
                        <div>
                            <Form.Label className='label-title'>รายละเอียดราคา</Form.Label>
                        </div>
                        <div>
                            <Button 
                                variant="outline-secondary" 
                                type="button" 
                                className=''
                                disabled={mode === 'view'}
                                onClick={event => calculatePrice ()}
                            >
                                คํานวณราคา
                                <i className="fa-solid fa-calculator ms-2"></i>
                            </Button>
                        </div>
                            <table cellPadding={4} className="table">
                                <thead>
                                    <tr>
                                        <th>ระยะเวลาแพ็กเกจ</th>
                                        {
                                            simulate.package_type === 'addon-user' &&
                                            <th>ปริมาณผู้ใช้</th>
                                        }
                                        {
                                            simulate.package_type === 'addon-storage' &&
                                            <th>ปริมาณการจัดเก็บข้อมูล</th>
                                        }
                                        <th>ราคา</th>
                                        <th className="text-center">ใช้งาน</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {packagePeriod?.map((obj, index) => (
                                         simulate?.arr_volume?.map((volume,index)=>(
                                            <tr key={index}>
                                            <td>{obj.name}</td>
                                            <td>{volume.volume}</td>
                                            <td > 
                                                <Form.Control
                                                    type="text"
                                                    name={`total|${obj.id}|${volume.id}`}
                                                    plaintext={mode === 'view'}
                                                    readOnly={mode === 'view'}
                                                    className="w-100"
                                                    value={
                                                        simulate?.arr_premium?.find(x => x.master_period_id === obj.id && x?.package_master_user_volume_id === volume.id)?.total ??
                                                        simulate?.arr_premium?.find(x => x.master_period_id === obj.id && x?.package_master_storage_volume_id === volume.id)?.total ??
                                                        calculatedPrices[index]
                                                    }
                                                    onChange={handleSetSimulatePremiums}
                                                    placeholder={"รายละเอียดราคา"}
                                                    required
                                                />
                                            </td>
                                            <td className="text-center">
                                                <Form.Switch 
                                                    name={`active|${obj.id}|${volume.id}`}
                                                    className="ms-0"
                                                    disabled={(mode === 'view') ? true : false}
                                                    checked={
                                                        simulate?.arr_premium?.find(x => x.master_period_id === obj.id && x?.package_master_user_volume_id === volume.id)?.active ?? 
                                                        simulate?.arr_premium?.find(x => x.master_period_id === obj.id && x?.package_master_storage_volume_id === volume.id)?.active ??
                                                        false
                                                    }
                                                    placeholder="ใช้งาน" 
                                                    onChange={handleSetSimulatePremiums} />
                                            </td>
                                        </tr>
                                        ))
                                    ))}
                                </tbody>
                            </table>
                    </Col>
                </Row>
            </>
        );
    }